var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBwSmileBad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mood-annoyed (1) 1",
    clipPath: "url(#clip0_3205_31913)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5 35C18.5302 35 16.5796 34.612 14.7597 33.8582C12.9399 33.1044 11.2863 31.9995 9.8934 30.6066C8.50052 29.2137 7.39563 27.5601 6.64181 25.7403C5.88799 23.9204 5.5 21.9698 5.5 20C5.5 18.0302 5.88799 16.0796 6.64181 14.2597C7.39563 12.4399 8.50052 10.7863 9.8934 9.3934C11.2863 8.00052 12.9399 6.89563 14.7597 6.14181C16.5796 5.38799 18.5302 5 20.5 5C24.4782 5 28.2936 6.58035 31.1066 9.3934C33.9196 12.2064 35.5 16.0218 35.5 20C35.5 23.9782 33.9196 27.7936 31.1066 30.6066C28.2936 33.4196 24.4782 35 20.5 35Z",
    stroke: "#727583",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.5 23.3334C22.1666 23.3334 20.5 25 19.6666 26.75",
    stroke: "#727583",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.4999 16.6666H15.4833",
    stroke: "#727583",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25.4999 16.6666H25.4833",
    stroke: "#727583",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3205_31913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBwSmileBad);
export default __webpack_public_path__ + "static/media/bw-smile-bad.20780be9ce4d284e4bc5d3aa89afcbe8.svg";
export { ForwardRef as ReactComponent };